export const STORE_CUSTOMER_DET = "customerDetails/STORE_CUSTOMER_DET"